import React, { useState } from 'react';
import { Newspaper, Sparkles, Heart, Share2, Eye, Calendar, User, ArrowLeft, ArrowRight, ShoppingBag } from 'lucide-react';

const MagazinePage = () => {
    const [lang, setLang] = useState(() => {
        try {
            const stored = localStorage.getItem('luxvono_geo_context');
            if (stored) {
                const parsed = JSON.parse(stored);
                if (parsed.language === 'ar') return 'ar';
            }
        } catch (_) {}
        return 'ar'; // Default to Arabic
    });

    const isRtl = lang === 'ar';

    const toggleLanguage = () => {
        setLang(prev => (prev === 'ar' ? 'en' : 'ar'));
    };

    const articles = [
        {
            tag: { ar: "صيحات الموضة", en: "FASHION TRENDS" },
            title: { ar: "أسبوع الموضة في ميلان: بساطة التصاميم وعودة الكلاسيكية", en: "Milan Fashion Week: The Return of Structured Classic Minimalism" },
            desc: { ar: "نستعرض أبرز تصاميم دور الأزياء الإيطالية لعام 2026، حيث هيمن اللون obsidian والذهبي المائل للنحاسي على منصات العروض مع تركيز كبير على جودة الأقمشة الفاخرة المستدامة.", en: "An in-depth review of the premier Italian luxury collections for 2026, dominated by rich obsidian hues and soft champagne golds." },
            author: "Elena Rostova",
            date: { ar: "22 مايو 2026", en: "May 22, 2026" },
            image: "https://images.unsplash.com/photo-1490481651871-ab68de25d43d?auto=format&fit=crop&q=80&w=800"
        },
        {
            tag: { ar: "حكايات الماركات", en: "BRAND HERITAGE" },
            title: { ar: "ما وراء كواليس صياغة المجوهرات الفريدة في جنيف", en: "Behind the Gates: Haute Joaillerie Sourcing in Geneva" },
            desc: { ar: "رحلة حصرية داخل ورش صياغة الألماس والمعادن النفيسة الفاخرة للتعرف على الدقة المتناهية والتاريخ الممتد لمئات السنين وراء القطع التي تُباع في صالات المزادات الكبرى.", en: "A rare privilege inside the world's most guarded gem-cutting studios, revealing the lineage of handcrafted diamond collections." },
            author: "Marc-Antoine",
            date: { ar: "18 مايو 2026", en: "May 18, 2026" },
            image: "https://images.unsplash.com/photo-1599643478518-a784e5dc4c8f?auto=format&fit=crop&q=80&w=800"
        }
    ];

    const t = {
        title: { ar: "مجلة لوكسفونو الرقمية", en: "LuxVono Digital Magazine" },
        subtitle: { ar: "نافذتك الحصرية على كواليس الموضة العالمية، حوارات المصممين، وتغطيات المعارض النادرة.", en: "Your curated lens into international runways, exclusive designer consultations, and high-fidelity artistry." },
        readMore: { ar: "اقرأ المقال كاملاً", en: "Read Full Editorial" },
        featured: { ar: "مختارات رئيسية مميزة", en: "Featured Editorial Column" }
    };

    return (
        <div 
            className="magazine-page-root"
            dir={isRtl ? 'rtl' : 'ltr'}
            style={{
                background: '#07080A',
                color: '#E5E5E5',
                minHeight: '100vh',
                fontFamily: "'Playfair Display', 'Outfit', 'Noto Sans Arabic', serif",
                paddingBottom: '80px',
                position: 'relative',
                overflowX: 'hidden'
            }}
        >
            <style dangerouslySetInnerHTML={{__html: `
                .magazine-page-root {
                    background: radial-gradient(circle at 50% 0%, #15181F 0%, #07080a 60%) !important;
                }
                .mag-header {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding: 24px 8%;
                    border-bottom: 1px solid rgba(255, 255, 255, 0.05);
                    background: rgba(7, 8, 10, 0.5);
                    backdrop-filter: blur(20px);
                }
                .mag-logo {
                    font-size: 26px;
                    font-weight: 800;
                    letter-spacing: 6px;
                    background: linear-gradient(135deg, #FFFFFF 30%, #C5A880 100%);
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                }
                .mag-lang-btn {
                    background: rgba(255, 255, 255, 0.03);
                    border: 1px solid rgba(255, 255, 255, 0.08);
                    border-radius: 40px;
                    padding: 8px 16px;
                    color: #FFFFFF;
                    font-size: 13px;
                    font-weight: 500;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    transition: all 0.3s ease;
                }
                .mag-lang-btn:hover {
                    background: rgba(197, 168, 128, 0.1);
                    border-color: rgba(197, 168, 128, 0.3);
                }
                .mag-hero {
                    max-width: 900px;
                    margin: 70px auto 50px auto;
                    text-align: center;
                    padding: 0 20px;
                }
                .mag-badge {
                    display: inline-flex;
                    align-items: center;
                    gap: 8px;
                    background: rgba(197, 168, 128, 0.06);
                    border: 1px solid rgba(197, 168, 128, 0.2);
                    color: #C5A880;
                    padding: 6px 20px;
                    border-radius: 50px;
                    font-size: 11px;
                    font-weight: 700;
                    letter-spacing: 2px;
                    text-transform: uppercase;
                    margin-bottom: 24px;
                }
                .mag-title {
                    font-size: clamp(34px, 6vw, 52px);
                    font-weight: 900;
                    line-height: 1.2;
                    margin-bottom: 20px;
                    color: #FFFFFF;
                }
                .mag-subtitle {
                    font-size: 16px;
                    color: #A3A3A3;
                    line-height: 1.7;
                    max-width: 700px;
                    margin: 0 auto;
                    font-family: 'Outfit', sans-serif;
                }
                .mag-container {
                    max-width: 1200px;
                    margin: 0 auto;
                    padding: 0 6%;
                }
                .mag-section-header {
                    font-size: 22px;
                    font-weight: 800;
                    margin-bottom: 40px;
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    border-bottom: 1px solid rgba(255, 255, 255, 0.06);
                    padding-bottom: 16px;
                    color: #FFFFFF;
                }
                .mag-article-layout {
                    display: flex;
                    flex-direction: column;
                    gap: 70px;
                    margin-bottom: 80px;
                }
                .mag-row {
                    display: grid;
                    grid-template-columns: 1.1fr 0.9fr;
                    gap: 60px;
                    align-items: center;
                }
                @media (max-width: 850px) {
                    .mag-row {
                        grid-template-columns: 1fr;
                        gap: 30px;
                    }
                    .mag-row.reverse-mobile {
                        display: flex;
                        flex-direction: column-reverse;
                    }
                }
                .mag-img-container {
                    position: relative;
                    border-radius: 24px;
                    overflow: hidden;
                    border: 1px solid rgba(255, 255, 255, 0.08);
                    box-shadow: 0 20px 40px rgba(0,0,0,0.5);
                }
                .mag-img {
                    width: 100%;
                    height: 400px;
                    object-fit: cover;
                    transition: transform 0.8s ease;
                }
                .mag-img-container:hover .mag-img {
                    transform: scale(1.05);
                }
                .mag-art-tag {
                    font-size: 11px;
                    font-weight: 700;
                    color: #C5A880;
                    letter-spacing: 2px;
                    text-transform: uppercase;
                    margin-bottom: 16px;
                    display: inline-block;
                }
                .mag-art-title {
                    font-size: clamp(24px, 3.5vw, 32px);
                    font-weight: 800;
                    line-height: 1.3;
                    margin-bottom: 20px;
                    color: #FFFFFF;
                }
                .mag-art-desc {
                    font-size: 15px;
                    color: #A3A3A3;
                    line-height: 1.8;
                    margin-bottom: 30px;
                    font-family: 'Outfit', sans-serif;
                }
                .mag-art-meta {
                    display: flex;
                    align-items: center;
                    gap: 20px;
                    font-size: 13px;
                    color: #737373;
                    font-family: 'Outfit', sans-serif;
                    margin-bottom: 30px;
                }
                .mag-author-avatar {
                    width: 32px;
                    height: 32px;
                    border-radius: 50%;
                    background: #1A1D26;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border: 1px solid rgba(255, 255, 255, 0.1);
                    color: #C5A880;
                    font-weight: 700;
                    font-size: 12px;
                }
                .mag-read-btn {
                    display: inline-flex;
                    align-items: center;
                    gap: 8px;
                    background: transparent;
                    border: 1px solid rgba(255, 255, 255, 0.15);
                    padding: 12px 28px;
                    border-radius: 50px;
                    color: #FFFFFF;
                    font-size: 14px;
                    font-weight: 600;
                    cursor: pointer;
                    text-decoration: none;
                    font-family: 'Outfit', sans-serif;
                    transition: all 0.3s ease;
                }
                .mag-read-btn:hover {
                    border-color: #C5A880;
                    color: #C5A880;
                    background: rgba(197, 168, 128, 0.04);
                    transform: translateY(-2px);
                }
            `}} />

            <header className="mag-header">
                <div className="mag-logo">LUXVONO</div>
                <button className="mag-lang-btn" onClick={toggleLanguage}>
                    <Newspaper size={14} style={{ color: '#C5A880' }} />
                    <span>{isRtl ? 'English' : 'العربية'}</span>
                </button>
            </header>

            <main className="mag-container">
                <div className="mag-hero">
                    <span className="mag-badge">
                        <Sparkles size={12} />
                        {isRtl ? "إصدار صيف 2026" : "Summer Issue 2026"}
                    </span>
                    <h1 className="mag-title">{isRtl ? t.title.ar : t.title.en}</h1>
                    <p className="mag-subtitle">{isRtl ? t.subtitle.ar : t.subtitle.en}</p>
                </div>

                <h2 className="mag-section-header">
                    <ShoppingBag size={20} style={{ color: '#C5A880' }} />
                    <span>{isRtl ? t.featured.ar : t.featured.en}</span>
                </h2>

                <div className="mag-article-layout">
                    {articles.map((art, idx) => {
                        const isEven = idx % 2 === 0;
                        return (
                            <div key={idx} className={`mag-row ${isEven ? '' : 'reverse-mobile'}`}>
                                {isEven ? (
                                    <>
                                        <div className="mag-img-container">
                                            <img src={art.image} alt="Luxury Fashion" className="mag-img" />
                                        </div>
                                        <div className="mag-content-pane">
                                            <span className="mag-art-tag">{isRtl ? art.tag.ar : art.tag.en}</span>
                                            <h3 className="mag-art-title">{isRtl ? art.title.ar : art.title.en}</h3>
                                            <div className="mag-art-meta">
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                    <div className="mag-author-avatar">{art.author[0]}</div>
                                                    <span>{art.author}</span>
                                                </div>
                                                <span>•</span>
                                                <span>{isRtl ? art.date.ar : art.date.en}</span>
                                            </div>
                                            <p className="mag-art-desc">{isRtl ? art.desc.ar : art.desc.en}</p>
                                            <button className="mag-read-btn">
                                                <span>{isRtl ? t.readMore.ar : t.readMore.en}</span>
                                                {isRtl ? <ArrowLeft size={16} /> : <ArrowRight size={16} />}
                                            </button>
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        <div className="mag-content-pane">
                                            <span className="mag-art-tag">{isRtl ? art.tag.ar : art.tag.en}</span>
                                            <h3 className="mag-art-title">{isRtl ? art.title.ar : art.title.en}</h3>
                                            <div className="mag-art-meta">
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                    <div className="mag-author-avatar">{art.author[0]}</div>
                                                    <span>{art.author}</span>
                                                </div>
                                                <span>•</span>
                                                <span>{isRtl ? art.date.ar : art.date.en}</span>
                                            </div>
                                            <p className="mag-art-desc">{isRtl ? art.desc.ar : art.desc.en}</p>
                                            <button className="mag-read-btn">
                                                <span>{isRtl ? t.readMore.ar : t.readMore.en}</span>
                                                {isRtl ? <ArrowLeft size={16} /> : <ArrowRight size={16} />}
                                            </button>
                                        </div>
                                        <div className="mag-img-container">
                                            <img src={art.image} alt="Luxury Jewelry Sourcing" className="mag-img" />
                                        </div>
                                    </>
                                )}
                            </div>
                        );
                    })}
                </div>
            </main>
        </div>
    );
};

export default MagazinePage;
